export class ChallengeMatch {
  constructor(form) {
    if (form) {
      this.type = form.type;
      this.id = form.id;
      this.name = form.name;
      this.content = form.content;
      this.duration = form.duration;
      this.introduction = form.introduction;
      this.matchImage = form.matchImage;
      this.numberOfDraws = form.numberOfDraws;
      this.sweepstakesRules = form.sweepstakesRules;
      this.prizeInformationAddDTOList = form.prizeInformationAddDTOList ? form.prizeInformationAddDTOList : [{
        prizeLevel: 1,
        prizeName: "",
        prizeNum: null,
      }];
    } else {
      this.clear();
    }
  }

  formatForm() {
    if (this.prizeInformationAddDTOList) {
      // 格式化掉没有名称的奖品
      this.prizeInformationAddDTOList = this.prizeInformationAddDTOList.filter((item, index) => {
        return item.prizeName && item.prizeNum && item.prizeNum != '0';
      });
      // 再格式化变量中的类型
      if (this.prizeInformationAddDTOList.length) {
        this.prizeInformationAddDTOList = this.prizeInformationAddDTOList?.map((item) => {
          return {
            ...item,
            prizeNum: Number(item.prizeNum),
          };
        });
      }
    }
  }

  clear() {
    this.type = 1;// 挑战赛类型
    this.id = "";
    this.name = ""; // 标题
    this.content = null; // 挑战内容
    this.duration = null; // 挑战时长
    this.introduction = ""; // 介绍
    this.matchImage = {
      listPictures: '', // 列表页图片
      matchDetailsPageHeader: '', // 挑战赛详情页头图
      myMatchListPictures: '', // 我的活动列表图片
      shareCardImage: '', // 分享卡片图片
      shareImage: '', // 分享长图
      userRankingSharing: '', // 用户排名分享图片
      acceptTheInvitationPop: '', // 接受邀请弹窗
    };
    this.sweepstakesRules = '';// 抽奖规则
    this.numberOfDraws = null;// 抽奖次数
    this.prizeInformationAddDTOList = [{
      prizeLevel: 1,
      prizeName: "",
      prizeNum: null,
    }]; // 奖品配置
  }
}
